import { isEmpty } from 'lodash';

import { FlowType } from '@jerry-serverless/types';

import { StepCategory, type AppData } from '../../../types/app_data';
import type { Step } from '../../types/step';

const canShow = (appData: AppData) => {
  return !isEmpty(appData.repairJob?.choices) || !isEmpty(appData.repairJob?.qnas);
};

export const GarageOnlyServiceDetailStep: Step = {
  id: 'garageonlyservicedetails',
  pathname: '/garageonlyservicedetails',
  canShow: (appData: AppData) => {
    return canShow(appData);
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    if (!canShow(appData)) {
      return true;
    }
    return !!appData.repairJobDetail;
  },
  category: (appData: AppData) =>
    appData.flowType === FlowType.RepairShop ? StepCategory.GarageOnlyService : StepCategory.GarageOnlyServices,
};
